// Paginator.Style.js - MUI 5 compatible styles

const paginatorStyles = {
  paginateFooter: (theme) => ({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: theme.spacing(2),
    borderTop: `1px solid ${theme.palette.divider}`,
    marginTop: theme.spacing(1),
    backgroundColor: theme.palette.background.paper,
    position: 'relative',
    zIndex: theme.zIndex.appBar - 1, // Ensure it appears above table content
    minHeight: 64 // Ensure consistent height
  }),

  pagePrev: (theme) => ({
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    gap: theme.spacing(1)
  }),

  pageNext: (theme) => ({
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    gap: theme.spacing(1)
  }),

  pageNumber: (theme) => ({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  }),

  fab: (theme) => ({
    margin: theme.spacing(0.5),
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    '&:hover': {
      backgroundColor: theme.palette.primary.dark
    },
    '&:disabled': {
      backgroundColor: theme.palette.action.disabled,
      color: theme.palette.action.disabled
    }
  }),

  button: (theme) => ({
    color: theme.palette.text.secondary,
    fontWeight: 'bold',
    textTransform: 'none',
    '&:disabled': {
      color: theme.palette.text.secondary
    }
  })
};

export default paginatorStyles; 